import { DocumentProgressStatus } from '../types';

/**
 * True when the export ended unsuccessfully — `Canceled` or `Failed`. Used
 * for UI affordances (error coloring, retry buttons) and for filtering out
 * terminated items from in-progress counts.
 */
export const isFailedDocumentProgressStatus = (
  status?: DocumentProgressStatus
): boolean =>
  status === DocumentProgressStatus.Canceled ||
  status === DocumentProgressStatus.Failed;
